import React, { useCallback } from 'react';
import { fieldToTextField } from 'formik-material-ui';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import { getIn } from 'formik';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    marginTop: theme.spacing(1),
    gap: `${theme.spacing(0.5)}px`,
    alignItems: 'center',
  },
}));

export const InputRange = (props: any) => {
  const classes = useStyles();
  const {
    form: { setFieldValue, values },
    field: { name },
  } = props;

  const handleOnChange = React.useCallback(
    (event) => {
      const { value } = event.target;
      if (Number.isInteger(parseInt(value))) {
        setFieldValue(name, parseInt(value));
      } else {
        setFieldValue(name, values[name] || '');
      }
    },
    [setFieldValue, name, values]
  );

  const handleOnMinus = useCallback(() => {
    const value = parseInt(getIn(values, name)) || 0;
    if (value > 0) {
      setFieldValue(name, value - 1);
    } else {
      setFieldValue(name, 0);
    }
  }, [setFieldValue, name, values]);

  const handleOnPlus = useCallback(() => {
    const value = parseInt(getIn(values, name)) || 0;
    setFieldValue(name, value + 1);
  }, [setFieldValue, name, values]);
  return (
    <FormControl>
      <FormLabel component="legend">{props.label}</FormLabel>
      <div className={classes.container}>
        <Button
          color="primary"
          variant="contained"
          onClick={handleOnMinus}
          disabled={props.disabled}
          disableElevation
        >
          -
        </Button>
        <TextField
          {...fieldToTextField(props)}
          variant="outlined"
          onChange={handleOnChange}
          disabled={props.disabled}
          label=""
        />
        <Button
          color="primary"
          variant="contained"
          onClick={handleOnPlus}
          disabled={props.disabled}
          disableElevation
        >
          +
        </Button>
      </div>
    </FormControl>
  );
};

export default InputRange;
